<template>
  <transition name="modal">
    <div class="modal-mask" @click="maskClicked($event)">
      <div class="modal-wrapper">
        <div class="modal-container">
          <Icon icon="fa6-solid:xmark" class="close-button" @click="$emit('close')" v-if="allowClose" />

          <div class="modal-header">
            <slot name="header">
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template >
<script>
export default {
  props: {
    allowClose: {
      default: true,
      type: Boolean
    }
  },
  methods: {
    maskClicked($event) {
      this.$emit('click', $event);
      if (this.allowClose)
        if ($event.target.className.indexOf('modal-wrapper') !== -1)
          this.$emit('close');
    }
  },
  mounted() {
    // Esc-to-close needs a document listener; the mask div isn't focusable, so the
    // old @keyup.esc on it only fired when focus already happened to be inside.
    this._escHandler = (e) => { if (e.key === 'Escape' && this.allowClose) this.$emit('close'); };
    window.addEventListener('keydown', this._escHandler);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this._escHandler);
  }
}
</script>
